import { validateLicense } from "components/StraightThroughHouseholdComp/CustomInputs/StateObjects/ValidateLicense";

export const UpdateHhm_ValidateFields = async ({ context, session }) => {

    if (Object.keys(session)?.length === 0) {
        return;
    }

    // Run validations concurrently
    var validationPromises = [
        ValidateEditDriverOption(session),
        ValidateEffDate(session),
        ValidateCurrentLicenseStatus(session),
        ValidateAgeLicensed(session),
        ValidateLicenseNumber(session, context),
        ValidateOccupation(session),
        ValidateConviction(session),
        ValidateMilitary(session),
        ValidateDisorders(session),
        ValidatePhysicalImpairments(session),
        ValidateDiffNameLicensed(session),
        ValidateDiffStateLicensed(session),
        ValidateMovingViolations(session),
        ValidateSuspended(session),
        ValidateStudent(session),
        ValidateSeriousMovingViolations(session),
        ValidateUnderInfluence(session),
        ValidateFailureToStopInjury(session),
        ValidateVehicleDamage(session),
        ValidateProvideInfoFailure(session),
        ValidateRecklessDriving(session)
    ];

    const validationResults = await Promise.all(validationPromises);
    var invalidResults = validationResults.filter(result => result.valid === false);

    return invalidResults;
}
const Validate = (value) => {
    if (value == undefined) { // No input on the screen
        return false
    } else if (value == "" || value == "Select from the following...") { // Input on screen value not filled
        return true
    } else { // Input is filled
        return false
    }
}

const ValidateEffDate = async (session) => {
    if(Validate(session?.requestedEffDate)){
        return { title: "Oops!", message: 'Please enter a valid Requested Effective Date.', valid: false };
    }
    return { valid: true }
}

const ValidateEditDriverOption = (session) => {
    if (Validate(session?.editType)) {
        return { title: "Oops!", message: 'Please select what you would like to edit about this driver.', valid: false };
    }
    return { valid: true }
}

const ValidateCurrentLicenseStatus = (session) => {
    if (Validate(session?.driverInfo?.licenseStatus)) {
        return { title: "Oops!", message: 'Please provide the current status of this driver\'s license.', valid: false };
    }
    return { valid: true }
}

const ValidateAgeLicensed = async (session) => {
    if (session?.driverInfo?.licenseStatus !== "Valid Foreign License" && Validate(session?.driverInfo?.licenseAge)) {
        return { title: "Oops!", message: 'Please enter the age this driver was licensed.', valid: false };
    }
    return { valid: true }
}

const ValidateLicenseNumber = async (session, context) => {
    if (Validate(session?.driverInfo?.licenseNumber)) {
        return { title: "Oops!", message: 'Please enter the license number for this driver.', valid: false };
    }
    if (session?.driverInfo?.licenseNumber && validateLicense(context.userData.state, session?.driverInfo?.licenseNumber)) {
        return { title: "Oops!", message: 'Please enter the correct format for a license.', valid: false };
    }
    return { valid: true }
}

const ValidateOccupation = async (session) => {
    if (Validate(session?.userInfo?.occupation)) {
        return { title: "Oops!", message: `Please provide this driver's occupation.`, valid: false };
    }
    return { valid: true }
}

const ValidateConviction = async (session) => {
    if (Validate(session?.violationInfo?.convicted)) {
        return {
            title: "Oops!", message: `Please provide if this driver has been convicted within the last 5 years of fraud or intent to defraud involving an insurance claim
            or an application for insurance.`, valid: false
        };
    }
    return { valid: true }
}

const ValidateMilitary = async (session) => {
    if (Validate(session?.userInfo?.militaryMember)) {
        return { title: "Oops!", message: `Please provide if this driver is a member of any branch of military.`, valid: false };
    }
    return { valid: true }
}

const ValidateDisorders = async (session) => {
    if (Validate(session?.disabilityInfo?.disorders)) {
        return { title: "Oops!", message: `Please provide if this driver has any disorders/conditions that may impair their ability to operate a motor vehicle.`, valid: false };
    }
    return { valid: true }
}

const ValidatePhysicalImpairments = async (session) => {
    if (Validate(session?.disabilityInfo?.physicalImpairments)) {
        return { title: "Oops!", message: `Please provide if this driver has any mental/physical impairments that would impair their ability to operate a motor vehicle.`, valid: false };
    }
    return { valid: true }
}

const ValidateDiffNameLicensed = async (session) => {
    if (Validate(session?.driverInfo?.diffNameLicensed)) {
        return { title: "Oops!", message: `Please provide if this driver has been licensed under a different name within the last 36 months.`, valid: false };
    }
    return { valid: true }
}
const ValidateDiffStateLicensed = async (session) => {
    if (Validate(session?.driverInfo?.diffStateLicensed)) {
        return { title: "Oops!", message: `Please provide if this driver has been licensed under a different state within the last 36 months.`, valid: false };
    }
    return { valid: true }
}

const ValidateMovingViolations = async (session) => {
    if (Validate(session?.violationInfo?.movingViolations)) {
        return { title: "Oops!", message: `Please provide if this driver received any moving violations and/or been in any accidents or claims within the last 36 months.`, valid: false };
    }
    return { valid: true }
}

const ValidateSuspended = async (session) => {
    if (Validate(session?.violationInfo?.driverSuspended)) {
        return { title: "Oops!", message: `Please provide if this driver's license has been suspended or in a suspended status within the last 36 months.`, valid: false };
    }
    return { valid: true }
}

const ValidateStudent = async (session) => {
    if (Validate(session?.schoolInfo?.enrolledInCollege)) {
        if (session?.editType === "Add as driver on policy." && session?.userInfo?.driverAge <= 24 && !session?.schoolInfo?.enrolledInCollege) {
            return { title: "Oops!", message: `Please provide if this driver is enrolled in college/university.`, valid: false };
        }
        if (Validate(session?.schoolInfo?.school100Miles)) {
            return { title: "Oops!", message: `Please provide if the school is over 100 miles away from the policy address.`, valid: false };
        }
        if (Validate(session?.schoolInfo?.schoolName)) {
            return { title: "Oops!", message: `Please provide the school name.`, valid: false };
        }
        if (Validate(session?.schoolInfo?.schoolCity)) {
            return { title: "Oops!", message: `Please provide the school city.`, valid: false };
        }
        if (Validate(session?.schoolInfo?.schoolState)) {
            return { title: "Oops!", message: `Please provide the school state.`, valid: false };
        }
    }
    return { valid: true }
}

const ValidateSeriousMovingViolations = async (session) => {
    if (Validate(session?.violationInfo?.seriousMovingViolations)) {
        return {
            title: "Oops!", message: `Please provide if this driver received any moving violations that resulted in death
            or serious impairment of body function within the last 3 years.`, valid: false
        };
    }
    return { valid: true }
}

const ValidateUnderInfluence = async (session) => {
    if (Validate(session?.violationInfo?.underInfluence)) {
        return { title: "Oops!", message: `Please provide if this driver has operated a motor vehicle while under influence within the last 3 years.`, valid: false };
    }
    return { valid: true }
}

const ValidateFailureToStopInjury = async (session) => {
    if (Validate(session?.violationInfo?.ftsInjury)) {
        return {
            title: "Oops!", message: `Please provide if this driver has failed to stop when involved in an accident that results in injury
            to any individual within the last 3 years.`, valid: false
        };
    }
    return { valid: true }
}

const ValidateVehicleDamage = async (session) => {
    if (Validate(session?.violationInfo?.vehicleDamage)) {
        return {
            title: "Oops!", message: `Please provide if this driver has failed to stop when involved in an accident that results in damage
            to a vehicle operated by or attended by any individual within the last 3 years.`, valid: false
        };
    }
    return { valid: true }
}

const ValidateProvideInfoFailure = async (session) => {
    if (Validate(session?.violationInfo?.provideInfoFailure)) {
        return {
            title: "Oops!", message: `Please provide if this driver has failed to provide required information or to provide reasonable
            assistance to an injured individual within the last 3 years.`, valid: false
        };
    }
    return { valid: true }
}

const ValidateRecklessDriving = async (session) => {
    if (Validate(session?.violationInfo?.recklessDriving)) {
        return {
            title: "Oops!", message: `Please provide if this driver has record of reckless driving, or a similar violation under the laws 
            of any other state or municipality in or outside of Michigan within the last 3 years.`, valid: false
        };
    }
    return { valid: true }
}